import { IActivity } from '@/service/types';
import { Box, Flex, Heading, Image, Skeleton } from '@chakra-ui/react';

export function ActivitySkeleton() {
  return <Skeleton width="100%" height="150px" borderRadius={'5px'} />;
}

export function Activity({
  activity,
  height = 150,
  centerLabel = false,
  borderRadius = 5,
  fullWidth = false,
}: {
  activity?: IActivity;
  centerLabel?: boolean;
  height?: number;
  borderRadius?: number;
  fullWidth?: boolean;
}) {
  if (!activity) return <ActivitySkeleton />;

  return (
    <Flex
      cursor="pointer"
      borderRadius="5px"
      width={fullWidth ? '100%' : '100%'}
      align={centerLabel ? 'center': 'flex-end'}
      justify={centerLabel ? 'center': 'flex-start'}
      height={height}
      boxSizing="border-box"
      overflow="hidden"
      position={'relative'}
    >
      <Image
        src={activity.image}
        transition="0.6s"
        width="100%"
        height={height}
        flexShrink="0"
        objectFit={'cover'}
        _hover={{
          transform: 'scale(1.2)',
        }}
        boxShadow="rgba(149, 157, 165, 0.2) 0px 8px 24px"
        borderRadius={borderRadius}
      />
      {centerLabel ? (
          <Heading
            textShadow={'0px 0px 10px rgba(0,0,0,0.8)'}
            position={'absolute'}
            margin={'auto'}
            color="white"
            fontFamily={'Glory'}
            fontSize={18}
          >
            {activity.name}
          </Heading>
      ) : (
        <>
          <Box
            position={'absolute'}
            left={0}
            right={0}
            width="100%"
            height="100%"
            background="linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 60%, rgba(0,0,0,0.70) 100%);"
            pointerEvents={'none'}
          ></Box>
          <Heading
            textShadow={'0px 0px 10px rgba(0,0,0,0.8)'}
            position={'absolute'}
            bottom={5}
            left={5}
            color="white"
            fontSize={18}
          >
            {activity.name}
          </Heading>
        </>
      )}
    </Flex>
  );
}
